import { HexPalette } from '../types'
import antDesign from './ant_design.json'
import discord from './discord.json'
import discord2 from './discord2.json'
import evergreen from './evergreen.json'
import example from './example.json'
import github from './github.json'
import google from './google.json'
import ibm from './ibm.json'
import semrush from './semrush.json'
import stripe from './stripe.json'
import uswds from './uswds.json'
import chakra_ui from './chakra_ui.json'
import radix_ui_dark from './radix_ui_dark.json'
import radix_ui_light from './radix_ui_light.json'
import tailwind from './tailwind.json'

export const PRESETS: HexPalette[] = [
  example,
  discord,
  discord2,
  semrush,
  stripe,
  chakra_ui,
  radix_ui_dark,
  radix_ui_light,
  tailwind,
  ibm,
  uswds,
  evergreen,
  google,
  github,
  antDesign,
]
